(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__kultowoBreadcrumbsRailMounted) {
      return;
    }

    window.__kultowoBreadcrumbsRailMounted = true;

    const selector = '[data-breadcrumbs-scroll-end="true"]';
    const mobileMedia = window.matchMedia("(max-width: 699px)");

    const getListMetrics = (list) => {
      const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      const rawScrollLeft = list.scrollLeft;

      if (document.documentElement.dir !== "rtl") {
        return {
          start: Math.max(0, rawScrollLeft),
          end: Math.max(0, maxScroll - rawScrollLeft),
        };
      }

      const normalizedScrollLeft = rawScrollLeft < 0 ? Math.abs(rawScrollLeft) : Math.max(0, maxScroll - rawScrollLeft);

      return {
        start: Math.max(0, normalizedScrollLeft),
        end: Math.max(0, maxScroll - normalizedScrollLeft),
      };
    };

    const updateScrollState = (nav) => {
      const list = nav?.querySelector(".breadcrumbs__list");

      if (!nav || !list || !mobileMedia.matches) {
        if (nav) {
          nav.dataset.canScrollStart = "false";
          nav.dataset.canScrollEnd = "false";
        }

        return;
      }

      const { start, end } = getListMetrics(list);

      nav.dataset.canScrollStart = start > 4 ? "true" : "false";
      nav.dataset.canScrollEnd = end > 4 ? "true" : "false";
    };

    const scrollListToEnd = (nav) => {
      const list = nav?.querySelector(".breadcrumbs__list");

      if (!nav || !list || !mobileMedia.matches) {
        updateScrollState(nav);
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (document.documentElement.dir === "rtl") {
            list.scrollLeft = 0;
          } else {
            list.scrollLeft = list.scrollWidth;
          }

          updateScrollState(nav);
        });
      });
    };

    const initializeRail = (nav) => {
      if (!nav) {
        return;
      }

      const list = nav.querySelector(".breadcrumbs__list");

      if (!list) {
        return;
      }

      if (nav.dataset.breadcrumbsRailReady != "true") {
        nav.dataset.breadcrumbsRailReady = "true";

        list.addEventListener("scroll", () => updateScrollState(nav), { passive: true });

        if ("ResizeObserver" in window) {
          const resizeObserver = new ResizeObserver(() => updateScrollState(nav));
          resizeObserver.observe(list);
        }
      }

      scrollListToEnd(nav);
    };

    const mount = (container = document) => {
      container.querySelectorAll(selector).forEach(initializeRail);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => mount());
    } else {
      mount();
    }

    document.addEventListener("shopify:section:load", (event) => mount(event.target));
    window.addEventListener("pageshow", () => mount());
    window.addEventListener("resize", () => document.querySelectorAll(selector).forEach(updateScrollState));
    mobileMedia.addEventListener("change", () => mount());
  })();
  } catch(e) { console.error(e); }
})();

})();
